// This allows us to define a publish schedule in advance and have these promos show/hide.
// The schedule is based on the current date and time. EX: unpublish_at: "2025-03-19T16:42:00" // please use this example set the time if needed

const promoDrawsScheduleConfig = {
  // Promo Draws
  // "C362B105-A0B8-4F1E-B8DB-BF3FC3CAA2D5": {
  //   key: "examplePromo1",
  //   publish_at: "2024-03-10T11:30:00",
  //   unpublish_at: "2025-07-20T20:00:00",
  //   draw_end: "2025-03-20T20:05:00"
  // },
  // "EA2917A2-2D69-4E51-9E9E-A532CADCF887": {
  //   key: "examplePromo2",
  //   publish_at: "2024-03-24T11:30:00",
  //   unpublish_at: "2025-04-16T20:00:00",
  //   draw_end: "2025-04-11T22:05:00"
  // },
  // "D1C1B0B0-8E66-4E59-BD6A-92DB1196B25D": {
  //   key: "1DayTestForWebsite",
  //   publish_at: "2025-04-01T08:00:00",
  //   unpublish_at: "2025-06-02T18:00:00",
  //   draw_end: "2025-06-02T00:00:00-04:00" // TODO: Double check timezone on all these config dates
  // },
  // "1E0D1EA7-46BE-45D3-B99E-DDA84BED2DFE": {
  // "3BD44206-2BD6-44E1-8845-01C7A839ADF6": {
  //   key: "multiMillionaireMaker2025",
  //   drawType: "poker",
  //   publish_at: "2025-04-01T08:00:00",
  //   unpublish_at: "2025-06-02T18:00:00",
  //   earning_start: "2025-04-01T08:00:00", // Use the Eastern time that we need, but dont add the -04:00
  //   earning_end: "2025-06-01T23:59:59", // Use the Eastern time that we need, but dont add the -04:00
  //   draw_end: "2025-06-02T00:00:00" // Use the Eastern time that we need, but dont add the -04:00
  // },
  "521": {
    key: "hockeyNightAtPlayground2025",
    drawType: "egd",
    publish_at: "2026-02-01T09:00:00",
    earning_start: "2026-02-01T09:00:00", // Use the Eastern time that we need, but dont add the -04:00
    earning_end: "2026-03-01T19:30:00", // Use the Eastern time that we need, but dont add the -04:00
    draw_end: "2026-03-01T20:30:00", // Use the Eastern time that we need, but dont add the -04:00
    unpublish_at: "2026-03-01T21:00:00"
  },
  "8B5BFDD4-8BAE-4C7D-9D65-9759E341D8A5": {
    key: "multiMillionaireMakerSeptember2025",
    drawType: "poker",
    publish_at: "2025-09-04T13:00:00",
    earning_start: "2025-09-08T09:00:00", // Use the Eastern time that we need, but dont add the -04:00
    earning_end: "2025-09-28T09:00:00", // Use the Eastern time that we need, but dont add the -04:00
    draw_end: "2025-09-28T19:00:00", // Use the Eastern time that we need, but dont add the -04:00
    unpublish_at: "2025-09-28T19:00:00"
  },
  // Triple Barrel Cash Blast February 2026 - Part 2 (Feb 2-15)
  "TRIPLE-BARREL-BLAST-FEBRUARY-2026-PT-2": {
    key: "tripleBarrelCashBlastFebruary2026",
    drawType: "poker",
    isMultiDraw: true,
    subDraws: [
      {
        promotionId: "0F676B91-3AC1-4192-8236-1A6889BA05F6",
        labelKey: "silver"
      },
      {
        promotionId: "F0E98862-2D0B-44AF-AF71-4E32A2C1A5AB",
        labelKey: "gold"
      },
      {
        promotionId: "69074CE9-D410-44F2-9484-70C0A716A6AE",
        labelKey: "diamond"
      }
    ],
    publish_at: "2026-02-01T20:00:00",
    earning_start: "2026-02-02T08:00:00",
    earning_end: "2026-02-15T08:00:00",
    draw_end: "2026-02-15T22:00:00",
    unpublish_at: "2026-02-16T01:00:00"
  },
  // Triple Barrel Cash Blast February 2026 - Part 3 (Feb 16 - Mar 1)
  "TRIPLE-BARREL-BLAST-FEBRUARY-2026-PT-3": {
    key: "tripleBarrelCashBlastFebruary2026",
    drawType: "poker",
    isMultiDraw: true,
    subDraws: [
      {
        promotionId: "11163EC3-E51C-4DAE-B8A0-D8F224BF22F1",
        labelKey: "silver"
      },
      {
        promotionId: "06D42FD6-8D26-40E4-8CE9-2D897C20AE0D",
        labelKey: "gold"
      },
      {
        promotionId: "EA75E5E4-C2DF-46CC-A79B-D362246AAA1C",
        labelKey: "diamond"
      }
    ],
    publish_at: "2026-02-16T01:00:00",
    earning_start: "2026-02-16T08:00:00",
    earning_end: "2026-03-01T08:00:00",
    draw_end: "2026-03-01T22:00:00",
    unpublish_at: "2026-03-02T01:00:00"
  },
  // Triple Barrel Cash Blast March 2026 (grouped multi-draw, silver/gold/diamond)
  "TRIPLE-BARREL-BLAST-MARCH-2026": {
    key: "tripleBarrelCashBlastMarch2026",
    drawType: "poker",
    isMultiDraw: true,
    subDraws: [
      {
        promotionId: "2843BF56-2823-4CF6-BBE8-03288562FD25",
        labelKey: "silver"
      },
      {
        promotionId: "530D5ED4-BB10-4FFA-A45A-9B273F076118",
        labelKey: "gold"
      },
      {
        promotionId: "BC00FC2E-FD80-4566-A81B-537FE65CDC67",
        labelKey: "diamond"
      }
    ],
    publish_at: "2026-03-02T00:10:00",
    earning_start: "2026-03-03T08:00:00",
    earning_end: "2026-03-22T21:55:00",
    draw_end: "2026-03-22T23:59:59",
    unpublish_at: "2026-03-23T01:00:00"
  },
  // Club Elite Saturday Draws - Week 2 (Nov 15)
  "CLUB-ELITE-WEEK-2-2025": {
    key: "clubEliteWeek2",
    drawType: "egd",
    isMultiDraw: true,
    mergeTickets: true,
    publish_at:     "2025-11-08T18:00:00",
    earning_start:  "2025-11-09T00:00:00", // Sunday 12:00 AM
    earning_end:    "2025-11-15T15:59:59", // Saturday 3:59 PM
    draw_end:       "2025-11-15T17:00:00",
    unpublish_at:   "2025-11-15T18:00:00",
    subDraws: [
      { promotionId: "458" },
      { promotionId: "462" }
    ]
  },
  // Club Elite Saturday Draws - Week 3 (Nov 22)
  "CLUB-ELITE-WEEK-3-2025": {
    key: "clubEliteWeek3",
    drawType: "egd",
    isMultiDraw: true,
    mergeTickets: true,
    publish_at:     "2025-11-15T18:00:00",
    earning_start:  "2025-11-16T00:00:00", // Sunday 12:00 AM
    earning_end:    "2025-11-22T15:59:59", // Saturday 3:59 PM
    draw_end:       "2025-11-22T17:00:00",
    unpublish_at:   "2025-11-22T18:00:00",
    subDraws: [
      { promotionId: "459" },
      { promotionId: "463" }
    ]
  },
  // Club Elite Saturday Draws - Week 4 (Nov 29)
  "CLUB-ELITE-WEEK-4-2025": {
    key: "clubEliteWeek4",
    drawType: "egd",
    isMultiDraw: true,
    mergeTickets: true,
    publish_at:     "2025-11-22T18:00:00",
    earning_start:  "2025-11-23T00:00:00", // Sunday 12:00 AM
    earning_end:    "2025-11-29T15:59:59", // Saturday 3:59 PM
    draw_end:       "2025-11-29T17:00:00",
    unpublish_at:   "2025-11-29T18:00:00",
    subDraws: [
      { promotionId: "460" },
      { promotionId: "464" }
    ]
  }
};

export default promoDrawsScheduleConfig;
